import { Button } from '@progress/kendo-react-buttons';
import { SvgIcon } from '@progress/kendo-react-common';
import { SVGIcon } from '@progress/kendo-svg-icons';
import {
    ChartsSankeySolid,
    CheckmarkCircleOutline,
    FileOutline,
    FilterOutline,
    FlightOutline,
    HelpCircleOutline,
    LayersOutline,
    LibraryOutline,
    MapOutline,
    StatusMonitorOutline,
    WeatherRadarSolid
} from '../../../../../icons/icons';
import { TutorialType } from '../../../../../onboarding/steps';
import CustomPopover from '../../../../components/layout/CustomPopover';
import { useAppDispatch } from '../../../../hooks/store-hooks';
import { setTutorial } from '../../../../state/slices/global-slice';

interface TutorialOption {
    id: TutorialType;
    name: string;
    duration: number;
    icon: SVGIcon;
}

const tutorials: TutorialOption[] = [
    { icon: MapOutline, name: 'Navigating the map and menus', id: 'home', duration: 1 },
    { icon: FileOutline, name: 'Create, update and select Views', id: 'createUdView', duration: 1 },
    { icon: FilterOutline, name: 'Filter aircraft displayed', id: 'myFleetAndFilter', duration: 3 },
    { icon: WeatherRadarSolid, name: 'Select weather layers', id: 'weather', duration: 2 },
    { icon: LayersOutline, name: 'Select map layers', id: 'layers', duration: 1 },
    { icon: FlightOutline, name: 'View aircraft details', id: 'flightDetails', duration: 2 },
    { icon: StatusMonitorOutline, name: 'Monitoring and Alerting', id: 'monitoringAlerting', duration: 3 },
    { icon: ChartsSankeySolid, name: 'Route analyzer', id: 'routeAnalyzer', duration: 2 },
    { icon: LibraryOutline, name: 'Drawing object', id: 'drawingObjects', duration: 2 },
    { icon: CheckmarkCircleOutline, name: 'Other tools', id: 'otherTools', duration: 4 }
];

export function TutorialToolbarItem() {
    const dispatch = useAppDispatch();
    const handleOpenTutorial = (item: TutorialOption) => {
        dispatch(setTutorial({ scenarioId: item.id }));
    };

    return (
        <CustomPopover
            title="Help/tutorials"
            trigger={
                <Button
                    id="tutorial-btn"
                    style={{
                        width: 27,
                        height: 27
                    }}
                    className="k-rounded-full"
                    data-tooltip-bottom
                    svgIcon={HelpCircleOutline}
                />
            }>
            <div className="d-flex flex-column gap-0 p-2" style={{ width: 280 }}>
                <div className="text-center">
                    <div className="fs-5">Take a tour!</div>
                    <div>Get started with:</div>

                    <div className="d-flex flex-column gap-2 mt-2">
                        {tutorials.map((x) => (
                            <div key={x.id} className="justify-content-start k-card clickable" onClick={() => handleOpenTutorial(x)}>
                                <div className="d-flex gap-3 align-items-center ps-3">
                                    <SvgIcon icon={x.icon} themeColor="primary" />
                                    <div className="d-flex flex-column align-items-start">
                                        <div>{x.name}</div>
                                        <div className="secondary-text">
                                            {x.duration} minute{x.duration > 1 ? 's' : ''}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className="d-flex gap-2 justify-content-between mt-2">
                        <Button onClick={() => dispatch(setTutorial({ scenarioId: 'whatsNew' }))}>What's new?</Button>
                        <Button themeColor={'primary'}>Close</Button>
                    </div>
                </div>
            </div>
        </CustomPopover>
    );
}
